import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router';
import { selectedDateWithoutTime } from '@store/global/selectors';
import { selectValidParams, selectDateRange, selectGridData } from '@pages/reporting-pages/deliveries-sku-dc/store/selectors';
import { SkuDcParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { setSearchParameters, setDateRange } from '@pages/reporting-pages/deliveries-sku-dc/store/slice';
import { DateRange } from '@project-types/DateRange';
import { useResetDeliveriesSkuDcMutation } from '@api/order-reporting/deliveryApi';
import { AppPage } from 'components/app-page/AppPage';
import ParamsToolbar from '@pages/reporting-pages/deliveries-sku-dc/params-toolbar/ParamsToolbar';
import Grid from '@pages/reporting-pages/deliveries-sku-dc/grid/Grid';
import { headersObject } from '@pages/reporting-pages/deliveries-sku-dc/headersObject';



const DeliveriesSkuDc = () => {

	const validParams = useSelector(selectValidParams);
	const dateWithoutTime = useSelector(selectedDateWithoutTime);
	const dateRange = useSelector(selectDateRange);
	const gridData = useSelector(selectGridData);

	const [ search, setSearch ] = useSearchParams();
	const dispatch = useDispatch();
	const updateSearchParameters = (parameters: SkuDcParams) => dispatch(setSearchParameters(parameters));
	const updateDateRange = (dateRange: DateRange) => dispatch(setDateRange(dateRange));

	const [ runReset ] = useResetDeliveriesSkuDcMutation();


	useEffect(() => {
		if (!dateRange) {
			updateDateRange({ from: dateWithoutTime, to: dateWithoutTime });
		}
	}, []);

	
	useEffect(() => {
		if (validParams) {
			setSearch({ ...validParams }, { replace: true });
		}
	}, [ validParams ]);

	
	useEffect(() => {
		if (search) {
			let paramDateFrom = search.get('dateFrom');
			let paramDateTo = search.get('dateTo');
			let paramMaterialId = search.get('materialId');

			if (!paramDateFrom || !paramDateTo || !paramMaterialId) return;

			let newSearchParams: SkuDcParams = {
				dateFrom: paramDateFrom,
				dateTo: paramDateTo,
				materialId: paramMaterialId,
			}
			updateSearchParameters(newSearchParams);
		}
	}, [ search ]);


	const resetAllApi = useCallback(() => {
		runReset();
	},[]);


	return (
		<AppPage
			className='reporting-page deliveries-sku-dc'
			pageLabel='Report dodávek - Sku DC'
			resetPageApi={resetAllApi}
			csvData={{
				headers: headersObject,
				data: gridData,
				filename: 'reporting-dodavky-sku-dc'
			}}
		>
			<ParamsToolbar />
			<Grid />
		</AppPage>
	)
};

export default DeliveriesSkuDc;